<template>
  <Loader v-if="loading"/>
  <div v-else-if="application">

    <Status :application="application"/>

    <section class="resolution__header">
      <div class="container-fluid">
        <div class="flex justify-between items-center">
          <router-link :to="{name: 'EmployeeApplicationsList'}" class="button__back">
            <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__left"></use></svg>
            {{ $lang.app.BACK }}
          </router-link>
          <div class="buttons__near relative">
            <Comments v-if="application.comments && application.comments.length" :comments="application.comments"/>
            <History/>
            <div v-if="this.application.actions.some(item => item.constName === 'APPLICATIONS_DOWNLOAD_ALL_SECTIONS_ACTION')"
                 class="button__dropdown">
              <a class="cursor-pointer button button--small white button__res__download"
                 @click="$emitter.emit('open-application-download-modal')">
                <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__download"></use>
                </svg>
                {{ $lang.app.DOWNLOAD }}
              </a>
            </div>
          </div>
        </div>
        <Actions :application="application"/>
        <h3 class="resolution__title break-words">{{ application.name }}</h3>
        <div class="resolution__basedata">
          <div class="row mb-4">
            <div class="col-xxl-2 col-xl-2">
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.APPLICATION_NUMBER }}</div>
                <div v-if="application.docNumber" class="stack__value">
                  <span>{{ application.docNumber }}</span>
                  <span class="text-gray-400">{{ application.docDate ? $moment(application.docDate).format('DD.MM.YYYY HH:mm') : '' }}</span>
                </div>
              </div>
            </div>
            <div class="col-xxl-2 col-xl-2 col-lg-2">
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.SEND_DATE }}</div>
                <div class="stack__value">{{ $moment(application.sendDate).format('DD.MM.YYYY') }}</div>
              </div>
            </div>
            <div class="col-xxl-2 col-xl-2 col-lg-2">
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.AGREEMENT }}</div>
                <div v-if="application.agreement?.number" class="stack__value">
                  {{ application.agreement.number }}
                </div>
              </div>
            </div>
            <div class="col-xxl-2 col-xl-2 col-lg-2">
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.AGREEMENT_DATE_AND_TIME }}</div>
                <div v-if="application.agreement.agreementDate" class="stack__value">{{ $moment(application.agreement.agreementDate).format('DD.MM.YYYY HH:mm') }}</div>
              </div>
            </div>
            <Deadline :application="application" @updated="deadline => application.deadline = deadline"/>
            <div v-if="application.payment" class="col-xxl-2 col-xl-2 col-lg-2">
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.RECEIPT }}</div>
                <div class="stack__value cursor-pointer"
                     @click="loadReceiptFile(application.payment?.receipt)">{{ application.payment?.receipt?.filename }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid pb-20">
      <div class="space__between">
        <div class="tabs">
          <ul class="nav">
            <li class="tab__item">
              <router-link :to="{name: 'EmployeeApplicationAgreement', params: {applicationId: application.id}}"
                           class="tab__link"
                           :class="{'link__active': $route.matched.some(item => item.name === 'EmployeeApplicationAgreement')}">
                {{ $lang.app.AGREEMENT }}</router-link>
            </li>
            <li class="tab__item">
              <router-link :to="{name: 'EmployeeApplicationDocuments', params: {applicationId: application.id}}"
                           class="tab__link"
                           :class="{'link__active': $route.matched.some(item => item.name === 'EmployeeApplicationDocuments')}">
                {{ $lang.app.DOCUMENTS }}</router-link>
            </li>
            <li class="tab__item">
              <router-link :to="{name: 'EmployeeApplicationMain', params: {applicationId: application.id}}"
                           class="tab__link"
                           :class="{'link__active': $route.matched.some(item => item.name === 'EmployeeApplicationMain')}">
                {{ $lang.app.MAIN_INFORMATION }}</router-link>
            </li>
            <li class="tab__item">
              <router-link :to="{name: 'EmployeeApplicationAdditionalFiles', params: {applicationId: application.id}}"
                           class="tab__link"
                           :class="{'link__active': $route.matched.some(item => item.name === 'EmployeeApplicationAdditionalFiles')}">
                {{ $lang.app.ADDITIONAL_FILES }}</router-link>
            </li>
          </ul>
        </div>
        <router-link :to="{name: 'EmployeeApplicationResolutions', params: {applicationId: application.id}}" class="resolution__link button__icon--left"
           :class="{'resolution__link--active': $route.matched.some(item => item.name === 'EmployeeApplicationResolutions')}">
          <svg viewBox="0 0 24 24" width="24" height="24" class="icon">
            <use xlink:href="@/assets/v2/img/sprite.svg#icon__folder"></use>
          </svg>
          {{ $lang.app.RESOLUTIONS }}
        </router-link>
      </div>
      <router-view :application="application"/>
    </div>

    <FooterActions :application="application"/>

    <EmployeeApplicationPdfFileModal/>
    <DownloadModal :application="application"/>

  </div>
</template>
<script>
import Loader from "../../../components/Loader.vue";
import Comments from "../../../components/employee/application/Comments.vue";
import History from "../../../components/employee/application/History.vue";

import Actions from "../../../components/employee/application/Actions"

import applicationApi from "../../../api/employee/application"
import EmployeeApplicationPdfFileModal
  from "../../../components/employee/application/modals/EmployeeApplicationPdfFileModal";
import Deadline from "../../../components/employee/application/Deadline";
import fileApi from "../../../api/file";
import DownloadModal from "@/components/employee/application/modals/DownloadModal";
import FooterActions from "../../../components/employee/application/FooterActions.vue";
import Status from "../../../components/employee/application/Status.vue";

export default {
  components: {
    Status,
    FooterActions,
    Loader,
    Actions,
    EmployeeApplicationPdfFileModal,
    Deadline,
    Comments,
    History,
    DownloadModal,
  },

  data() {
    return {
      loading: false,
      application: null,
    };
  },

  created() {
    this.fetchApplication()
  },

  beforeMount() {
    this.$emitter.on('refresh-application', (payload) => {
      if(!payload) {
        this.fetchApplication()
      } else {
        this.fetchApplication(payload.reload)
      }
    })
  },

  beforeUnmount() {
    this.$emitter.off('refresh-application')
  },

  methods: {
    fetchApplication(reload = true) {
      if(reload) {
        this.loading = true
      }
      applicationApi
          .getApplication(this.$route.params.applicationId)
          .then(response => {
            this.application = response.data;
          })
          .catch(error => {
            this.$snotify.error(error);
          }).finally(() => {
        this.loading = false;
      })
    },
    loadReceiptFile(file) {
      this.$emitter.emit('open-loader-modal')
      fileApi.getEmployeeApplicationFile(file.id, this.$route.params.applicationId).then(res => {
        this.$emitter.emit('open-file-modal', res.data)
      }).catch(error => {
        this.$snotify.error(error)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
  },
};
</script>
